// src/utils/ToastHandle.js

let activeSpinnerToast = null;

export function showToast(message, type = 'info', withSpinner = false) {
  const toast = document.createElement('div');
  toast.className = `custom-toast ${type}`;
  toast.textContent = message;

  toast.style.position = 'fixed';
  toast.style.left = '50%';
  toast.style.transform = 'translateX(-50%)';
  toast.style.bottom = `${20 + document.querySelectorAll('.custom-toast').length * 70}px`;
  toast.style.padding = '12px 16px';
  toast.style.borderRadius = '8px';
  toast.style.backgroundColor =
    type === 'error' ? '#ef4444' :
    type === 'success' ? '#22c55e' :
    '#0ea5a3';
  toast.style.color = '#fff';
  toast.style.fontSize = '14px';
  toast.style.fontWeight = '600';
  toast.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
  toast.style.zIndex = 19999;
  toast.style.transition = 'opacity 0.3s ease';
  toast.style.opacity = '1';

  if (withSpinner) {
    const spinner = document.createElement('span');
    spinner.className = 'toast-spinner';
    spinner.style.display = 'inline-block';
    spinner.style.width = '16px';
    spinner.style.height = '16px';
    spinner.style.border = '2px solid rgba(255,255,255,0.4)';
    spinner.style.borderTop = '2px solid white';
    spinner.style.borderRadius = '50%';
    spinner.style.marginRight = '8px';
    spinner.style.animation = 'spin 1s linear infinite';
    toast.prepend(spinner);

    activeSpinnerToast = toast;
  }

  document.body.appendChild(toast);

  // Auto-remove normal toasts after 2s
  if (!withSpinner) {
    setTimeout(() => removeToast(toast), 2000);
  }

  // ✅ Return the toast element so caller can dismiss manually
  return toast;
}

export function removeToast(toast) {
  if (!toast) return; // guard against undefined/null
  toast.style.opacity = '0';
  setTimeout(() => {
    if (document.body.contains(toast)) {
      document.body.removeChild(toast);

      // Reposition remaining toasts
      const allToasts = Array.from(document.querySelectorAll('.custom-toast'));
      allToasts.forEach((t, i) => {
        t.style.bottom = `${20 + i * 70}px`;
      });
    }
  }, 500);

  if (toast === activeSpinnerToast) {
    activeSpinnerToast = null;
  }
}

// Optional helper to clear the active spinner toast if you don't have a reference
export function removeActiveSpinnerToast() {
  if (activeSpinnerToast) {
    removeToast(activeSpinnerToast);
    activeSpinnerToast = null;
  }
}

// Simple keyframe injection for spinner (only added once)
if (!document.getElementById('toast-spinner-style')) {
  const style = document.createElement('style');
  style.id = 'toast-spinner-style';
  style.innerHTML = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}
